import { useLocation } from 'react-router-dom';

const getPathSegment = () => {
  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1];
  return pathSegment;
};

const getQueryParam = (param: string): string | null => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(param);
};

export { getPathSegment, getQueryParam };
